import {
  GET_PRODUCT_LIST,
  GET_PRODUCT_LIST_SUCCESS,
  GET_PRODUCT_LIST_ERROR,
  GET_PRODUCT_UNIT_TYPE_LIST,
  GET_PRODUCT_UNIT_TYPE_LIST_SUCCESS,
  GET_PRODUCT_UNIT_TYPE_LIST_ERROR,
  ADD_PRODUCT_UNIT_TYPE,
  ADD_PRODUCT_UNIT_TYPE_SUCCESS,
  ADD_PRODUCT_UNIT_TYPE_ERROR,
  UPDATE_PRODUCT_UNIT_TYPE,
  UPDATE_PRODUCT_UNIT_TYPE_SUCCESS,
  UPDATE_PRODUCT_UNIT_TYPE_ERROR,
  DELETE_PRODUCT_UNIT_TYPE,
  DELETE_PRODUCT_UNIT_TYPE_SUCCESS,
  DELETE_PRODUCT_UNIT_TYPE_ERROR,
  GET_PRODUCT_STOCK_STORAGE_LOCATION_LIST,
  GET_PRODUCT_STOCK_STORAGE_LOCATION_LIST_SUCCESS,
  GET_PRODUCT_STOCK_STORAGE_LOCATION_LIST_ERROR,
  GET_PRODUCT_STOCK_STORAGE_LOCATION_DATA,
  GET_PRODUCT_STOCK_STORAGE_LOCATION_DATA_SUCCESS,
  GET_PRODUCT_STOCK_STORAGE_LOCATION_DATA_ERROR,
  CREATE_PRODUCT_STOCK_STORAGE_LOCATION,
  CREATE_PRODUCT_STOCK_STORAGE_LOCATION_SUCCESS,
  CREATE_PRODUCT_STOCK_STORAGE_LOCATION_ERROR,
  UPDATE_PRODUCT_STOCK_STORAGE_LOCATION,
  UPDATE_PRODUCT_STOCK_STORAGE_LOCATION_SUCCESS,
  UPDATE_PRODUCT_STOCK_STORAGE_LOCATION_ERROR,
  DELETE_PRODUCT_STOCK_STORAGE_LOCATION,
  DELETE_PRODUCT_STOCK_STORAGE_LOCATION_SUCCESS,
  DELETE_PRODUCT_STOCK_STORAGE_LOCATION_ERROR,
  GET_PRODUCT_STOCK_LIST,
  GET_PRODUCT_STOCK_LIST_SUCCESS,
  GET_PRODUCT_STOCK_LIST_ERROR,
  SEARCH_PRODUCT_STOCK,
  SEARCH_PRODUCT_STOCK_SUCCESS,
  SEARCH_PRODUCT_STOCK_ERROR,
  SEARCH_PRODUCT_STOCK_TRANSACTION,
  SEARCH_PRODUCT_STOCK_TRANSACTION_SUCCESS,
  SEARCH_PRODUCT_STOCK_TRANSACTION_ERROR,
  GET_PRODUCT_STOCK_TRANSACTION_LIST,
  GET_PRODUCT_STOCK_TRANSACTION_LIST_SUCCESS,
  GET_PRODUCT_STOCK_TRANSACTION_LIST_ERROR,
  ADD_PRODUCT_STOCK_TRANSACTION,
  ADD_PRODUCT_STOCK_TRANSACTION_SUCCESS,
  ADD_PRODUCT_STOCK_TRANSACTION_ERROR,
  MOVE_PRODUCT_STOCK_TRANSACTION,
  MOVE_PRODUCT_STOCK_TRANSACTION_SUCCESS,
  MOVE_PRODUCT_STOCK_TRANSACTION_ERROR,
  REDUCE_PRODUCT_STOCK_TRANSACTION,
  REDUCE_PRODUCT_STOCK_TRANSACTION_SUCCESS,
  REDUCE_PRODUCT_STOCK_TRANSACTION_ERROR,
  GET_PRODUCT_STOCK_TRANSACTION_REASON_LIST,
  GET_PRODUCT_STOCK_TRANSACTION_REASON_LIST_SUCCESS,
  GET_PRODUCT_STOCK_TRANSACTION_REASON_LIST_ERROR,
  CREATE_PRODUCT_STOCK_TRANSACTION_REASON,
  CREATE_PRODUCT_STOCK_TRANSACTION_REASON_SUCCESS,
  CREATE_PRODUCT_STOCK_TRANSACTION_REASON_ERROR,
  UPDATE_PRODUCT_STOCK_TRANSACTION_REASON,
  UPDATE_PRODUCT_STOCK_TRANSACTION_REASON_SUCCESS,
  UPDATE_PRODUCT_STOCK_TRANSACTION_REASON_ERROR,
  DELETE_PRODUCT_STOCK_TRANSACTION_REASON,
  DELETE_PRODUCT_STOCK_TRANSACTION_REASON_SUCCESS,
  DELETE_PRODUCT_STOCK_TRANSACTION_REASON_ERROR,
  GET_UNIT_MEASUREMENT_LIST,
  GET_UNIT_MEASUREMENT_LIST_SUCCESS,
  GET_UNIT_MEASUREMENT_LIST_ERROR,
} from "./actionType";

// get product list Action Types

export const getProductList = () => ({
  type: GET_PRODUCT_LIST,
});

export const getProductListSuccess = (data) => ({
  type: GET_PRODUCT_LIST_SUCCESS,
  payload: data,
});

export const getProductListError = (error) => ({
  type: GET_PRODUCT_LIST_ERROR,
  payload: error,
});

// get product unit type list Action Types

// get product unit types list
export const getProductUnitTypeList = () => ({
  type: GET_PRODUCT_UNIT_TYPE_LIST,
});

export const getProductUnitTypeListSuccess = (data) => ({
  type: GET_PRODUCT_UNIT_TYPE_LIST_SUCCESS,
  payload: data,
});

export const getProductUnitTypeListError = (error) => ({
  type: GET_PRODUCT_UNIT_TYPE_LIST_ERROR,
  payload: error,
});

// add product unit type
export const addProductUnitType = (data) => ({
  type: ADD_PRODUCT_UNIT_TYPE,
  payload: data,
});

export const addProductUnitTypeSuccess = (data) => ({
  type: ADD_PRODUCT_UNIT_TYPE_SUCCESS,
  payload: data,
});

export const addProductUnitTypeError = (error) => ({
  type: ADD_PRODUCT_UNIT_TYPE_ERROR,
  payload: error,
});

// update product unit type
export const updateProductUnitType = (data) => ({
  type: UPDATE_PRODUCT_UNIT_TYPE,
  payload: data,
});

export const updateProductUnitTypeSuccess = (data) => ({
  type: UPDATE_PRODUCT_UNIT_TYPE_SUCCESS,
  payload: data,
});

export const updateProductUnitTypeError = (error) => ({
  type: UPDATE_PRODUCT_UNIT_TYPE_ERROR,
  payload: error,
});

// delete product unit type
export const deleteProductUnitType = (data) => ({
  type: DELETE_PRODUCT_UNIT_TYPE,
  payload: data,
});

export const deleteProductUnitTypeSuccess = (data) => ({
  type: DELETE_PRODUCT_UNIT_TYPE_SUCCESS,
  payload: data,
});

export const deleteProductUnitTypeError = (error) => ({
  type: DELETE_PRODUCT_UNIT_TYPE_ERROR,
  payload: error,
});

// get product stock storage location list Action Types

export const getProductStockStorageLocationList = () => ({
  type: GET_PRODUCT_STOCK_STORAGE_LOCATION_LIST,
});

export const getProductStockStorageLocationListSuccess = (data) => ({
  type: GET_PRODUCT_STOCK_STORAGE_LOCATION_LIST_SUCCESS,
  payload: data,
});

export const getProductStockStorageLocationListError = (error) => ({
  type: GET_PRODUCT_STOCK_STORAGE_LOCATION_LIST_ERROR,
  payload: error,
});

// get product stock storage location data Action Types

export const getProductStockStorageLocationData = (data) => ({
  type: GET_PRODUCT_STOCK_STORAGE_LOCATION_DATA,
  payload: data,
});

export const getProductStockStorageLocationDataSuccess = (data) => ({
  type: GET_PRODUCT_STOCK_STORAGE_LOCATION_DATA_SUCCESS,
  payload: data,
});

export const getProductStockStorageLocationDataError = (error) => ({
  type: GET_PRODUCT_STOCK_STORAGE_LOCATION_DATA_ERROR,
  payload: error,
});

// create product stock storage location Action Types

export const createProductStockStorageLocation = (data) => ({
  type: CREATE_PRODUCT_STOCK_STORAGE_LOCATION,
  payload: data,
});

export const createProductStockStorageLocationSuccess = (data) => ({
  type: CREATE_PRODUCT_STOCK_STORAGE_LOCATION_SUCCESS,
  payload: data,
});

export const createProductStockStorageLocationError = (error) => ({
  type: CREATE_PRODUCT_STOCK_STORAGE_LOCATION_ERROR,
  payload: error,
});

// update product stock storage location Action Types

export const updateProductStockStorageLocation = (data) => ({
  type: UPDATE_PRODUCT_STOCK_STORAGE_LOCATION,
  payload: data,
});

export const updateProductStockStorageLocationSuccess = (data) => ({
  type: UPDATE_PRODUCT_STOCK_STORAGE_LOCATION_SUCCESS,
  payload: data,
});

export const updateProductStockStorageLocationError = (error) => ({
  type: UPDATE_PRODUCT_STOCK_STORAGE_LOCATION_ERROR,
  payload: error,
});

// delete product stock storage location Action Types

export const deleteProductStockStorageLocation = (data) => ({
  type: DELETE_PRODUCT_STOCK_STORAGE_LOCATION,
  payload: data,
});

export const deleteProductStockStorageLocationSuccess = (data) => ({
  type: DELETE_PRODUCT_STOCK_STORAGE_LOCATION_SUCCESS,
  payload: data,
});

export const deleteProductStockStorageLocationError = (error) => ({
  type: DELETE_PRODUCT_STOCK_STORAGE_LOCATION_ERROR,
  payload: error,
});

// get product stock list Action Types

export const getProductStockList = () => ({
  type: GET_PRODUCT_STOCK_LIST,
});

export const getProductStockListSuccess = (data) => ({
  type: GET_PRODUCT_STOCK_LIST_SUCCESS,
  payload: data,
});

export const getProductStockListError = (error) => ({
  type: GET_PRODUCT_STOCK_LIST_ERROR,
  payload: error,
});

// search product stock Action Types

export const searchProductStock = (data) => ({
  type: SEARCH_PRODUCT_STOCK,
  payload: data,
});

export const searchProductStockSuccess = (data) => ({
  type: SEARCH_PRODUCT_STOCK_SUCCESS,
  payload: data,
});

export const searchProductStockError = (error) => ({
  type: SEARCH_PRODUCT_STOCK_ERROR,
  payload: error,
});

// search product stock transaction Action Types

export const searchProductStockTransaction = (data) => ({
  type: SEARCH_PRODUCT_STOCK_TRANSACTION,
  payload: data,
});

export const searchProductStockTransactionSuccess = (data) => ({
  type: SEARCH_PRODUCT_STOCK_TRANSACTION_SUCCESS,
  payload: data,
});

export const searchProductStockTransactionError = (error) => ({
  type: SEARCH_PRODUCT_STOCK_TRANSACTION_ERROR,
  payload: error,
});

// get product stock transaction list Action Types

export const getProductStockTransactionList = () => ({
  type: GET_PRODUCT_STOCK_TRANSACTION_LIST,
});

export const getProductStockTransactionListSuccess = (data) => ({
  type: GET_PRODUCT_STOCK_TRANSACTION_LIST_SUCCESS,
  payload: data,
});

export const getProductStockTransactionListError = (error) => ({
  type: GET_PRODUCT_STOCK_TRANSACTION_LIST_ERROR,
  payload: error,
});

// add product stock transaction Action Types

export const addProductStockTransaction = (data) => ({
  type: ADD_PRODUCT_STOCK_TRANSACTION,
  payload: data,
});

export const addProductStockTransactionSuccess = (data) => ({
  type: ADD_PRODUCT_STOCK_TRANSACTION_SUCCESS,
  payload: data,
});

export const addProductStockTransactionError = (error) => ({
  type: ADD_PRODUCT_STOCK_TRANSACTION_ERROR,
  payload: error,
});

// move product stock transaction Action Types

export const moveProductStockTransaction = (data) => ({
  type: MOVE_PRODUCT_STOCK_TRANSACTION,
  payload: data,
});

export const moveProductStockTransactionSuccess = (data) => ({
  type: MOVE_PRODUCT_STOCK_TRANSACTION_SUCCESS,
  payload: data,
});

export const moveProductStockTransactionError = (error) => ({
  type: MOVE_PRODUCT_STOCK_TRANSACTION_ERROR,
  payload: error,
});

// reduce product stock transaction Action Types

export const reduceProductStockTransaction = (data) => ({
  type: REDUCE_PRODUCT_STOCK_TRANSACTION,
  payload: data,
});

export const reduceProductStockTransactionSuccess = (data) => ({
  type: REDUCE_PRODUCT_STOCK_TRANSACTION_SUCCESS,
  payload: data,
});

export const reduceProductStockTransactionError = (error) => ({
  type: REDUCE_PRODUCT_STOCK_TRANSACTION_ERROR,
  payload: error,
});

// product stock transaction reason (reduction reason picklist) Action Types

export const getProductStockTransactionReasonList = () => ({
  type: GET_PRODUCT_STOCK_TRANSACTION_REASON_LIST,
});

export const getProductStockTransactionReasonListSuccess = (data) => ({
  type: GET_PRODUCT_STOCK_TRANSACTION_REASON_LIST_SUCCESS,
  payload: data,
});

export const getProductStockTransactionReasonListError = (error) => ({
  type: GET_PRODUCT_STOCK_TRANSACTION_REASON_LIST_ERROR,
  payload: error,
});

export const createProductStockTransactionReason = (data) => ({
  type: CREATE_PRODUCT_STOCK_TRANSACTION_REASON,
  payload: data,
});

export const createProductStockTransactionReasonSuccess = (data) => ({
  type: CREATE_PRODUCT_STOCK_TRANSACTION_REASON_SUCCESS,
  payload: data,
});

export const createProductStockTransactionReasonError = (error) => ({
  type: CREATE_PRODUCT_STOCK_TRANSACTION_REASON_ERROR,
  payload: error,
});

export const updateProductStockTransactionReason = (data) => ({
  type: UPDATE_PRODUCT_STOCK_TRANSACTION_REASON,
  payload: data,
});

export const updateProductStockTransactionReasonSuccess = (data) => ({
  type: UPDATE_PRODUCT_STOCK_TRANSACTION_REASON_SUCCESS,
  payload: data,
});

export const updateProductStockTransactionReasonError = (error) => ({
  type: UPDATE_PRODUCT_STOCK_TRANSACTION_REASON_ERROR,
  payload: error,
});

export const deleteProductStockTransactionReason = (data) => ({
  type: DELETE_PRODUCT_STOCK_TRANSACTION_REASON,
  payload: data,
});

export const deleteProductStockTransactionReasonSuccess = (data) => ({
  type: DELETE_PRODUCT_STOCK_TRANSACTION_REASON_SUCCESS,
  payload: data,
});

export const deleteProductStockTransactionReasonError = (error) => ({
  type: DELETE_PRODUCT_STOCK_TRANSACTION_REASON_ERROR,
  payload: error,
});

// GET_UNIT_MEASUREMENT_LIST
export const getUnitMeasurementList = () => ({
  type: GET_UNIT_MEASUREMENT_LIST,
});
export const getUnitMeasurementListSuccess = (data) => ({
  type: GET_UNIT_MEASUREMENT_LIST_SUCCESS,
  payload: data,
});
export const getUnitMeasurementListError = (error) => ({
  type: GET_UNIT_MEASUREMENT_LIST_ERROR,
  payload: error,
});
